/**
 * Fetch paginated user events.
 */
export async function fetchUserEvents(
  token,
  {
    limit = 10,
    cursor = null,
    status = "",
    search = "",
    isSilent = false,
  } = {},
) {
  if (!token || isSilent) {
    return { items: [], nextCursor: null };
  }

  try {
    const url = new URL("https://api.kloudscan.com/user-events");
    url.searchParams.set("limit", limit);
    if (cursor) url.searchParams.set("cursor", cursor);
    if (status) url.searchParams.set("status", status);
    if (search) url.searchParams.set("search", search);

    const res = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      cache: "no-store",
    });

    if (res.status === 401 || res.status === 403) {
      console.warn("[fetchUserEvents] Unauthorized or expired token");
      throw new Error("unauthorized");
    }

    if (res.status === 404) {
      return { items: [], nextCursor: null };
    }

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`user-events ${res.status}: ${text || res.statusText}`);
    }

    const text = await res.text();
    const json = JSON.parse(text || "{}");

    return {
      items: Array.isArray(json?.items) ? json.items : [],
      nextCursor: json?.nextCursor ?? null,
    };
  } catch (err) {
    if (err.message !== "unauthorized") {
      console.warn("[fetchUserEvents] failed:", err.message);
    }
    return { items: [], nextCursor: null };
  }
}

/**
 * Fetch ALL user events by looping through all cursors.
 * Used for in-browser filtering and pagination.
 */
export async function fetchAllUserEvents(token) {
  if (!token) return [];

  let allItems = [];
  let cursor = null;

  do {
    const result = await fetchUserEvents(token, { limit: 100, cursor });
    allItems = allItems.concat(result.items);
    cursor = result.nextCursor;
  } while (cursor);

  return allItems;
}
